import React, { useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import axios from "axios";
import { Box, Button, IconButton, LinearProgress, Modal, TextField } from '@mui/material';
import { ArrowForward, Clear, GpsFixed } from '@mui/icons-material';
import Backbutton from '../Components/backicon';
import { Erroralert, Successalert } from '../Components/popups';
import Lottie from "lottie-react";
import paymentlottie from "./../../assets/lotties/payment.json"
import successlottie from "./../../assets/lotties/tick.json"
import { Fetchsearchrequesturl, Postsearchrequest, Recovertrackingnumberurl } from '../Utils/urls';
import { getsessionuser, gettrackingnumbers, settrackingnumbers } from '../Utils/sessions';
import { admindetails } from '../Utils/defaults';
import { contacttypes, numberofdays, roomdetails, roomtypes, semesterroomtypes } from '../Utils/arrays';
import Select from 'react-select';
import { currencyseperator, gottowhatsapp } from '../Utils/functions';



export default function Hireagentmodal({ ondismiss }) {


    const [showonboarding, setshowonboarding] = useState(true);
    const [showform, setshowform] = useState(false);
    const [showcheckstatus, setshowcheckstatus] = useState(false);

 


    return (
        <Modal
            open={true}
            onClose={() => ondismiss()}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Container component="main" maxWidth="sm" style={{ backgroundColor: "white", marginTop: 5, borderRadius: 20 }}>
                <CssBaseline />

                {showform &&
                    <Userform ongoback={() => {
                        setshowform(false)
                        setshowcheckstatus(false)
                        setshowonboarding(true)
                    }} ondismiss={ondismiss} />
                }
                {showcheckstatus &&
                    <Checksearchstatus ongoback={() => {
                        setshowform(false)
                        setshowcheckstatus(false)
                        setshowonboarding(true)
                    }} ondismiss={ondismiss} />
                }
                {showonboarding &&
                    <div style={{ width: "100%" }}>
                        <p align="right">
                            <IconButton onClick={() => ondismiss()}>
                                <Clear />
                            </IconButton>
                        </p>
                        <div className='agentillustration'>
                            <img src={require("./../../assets/hostels/search3.png")} style={{ width: "100%" }} />
                        </div>

                        <div className='agenttitle'>Hire an agent to find a house for you for as low as 599ksh</div>
                        {/* <div className='agentdescription'>
                            It's time to bring in the experts!.
                            Hire an agent to find a house for you for as low as 599ksh'
                        </div> */}
                        <p align="middle">
                            <Button onClick={() => {
                                gottowhatsapp()
                                // setshowform(true)
                                // setshowcheckstatus(false)
                                // setshowonboarding(false)
                            }} variant='contained' endIcon={<ArrowForward />}>
                                Continue
                            </Button>
                        </p>
                        {/* <Button onClick={() => {
                            setshowform(false)
                            setshowcheckstatus(true)
                            setshowonboarding(false)
                        }} sx={{ alignSelf: "end", fontSize: 12 }} startIcon={<GpsFixed />}>track my request</Button> */}
                    </div>}
                <br /><br />
            </Container>
        </Modal>

    );
}


const Userform = ({ ongoback, ondismiss }) => {
    const trackingnumbers = gettrackingnumbers()
    const user = getsessionuser()

    const [name, setName] = useState(user?.username);
    const [email, setEmail] = useState(user?.email);
    const [phone, setPhone] = useState(user?.phone);
    const [mphone, setMPhone] = useState(null);
    const [mode, setMode] = useState(null);
    const [plan, setPlan] = useState("semester");
    const [budget, setBudget] = useState(null);
    const [timeframe, setTimeframe] = useState(null);
    const [roomtype, setRoomtype] = useState(null);
    const [facilities, setFacilities] = useState(null);
    const [distance, setDistance] = useState(null);
    const [location, setLocation] = useState(null);
    const [aob, setAob] = useState(null);

    const [distancearray, setdistancearray] = useState([]);

    const [loading, setloading] = useState(false);
    const [error, seterror] = useState('');
    const [success, setsuccess] = useState('');


    const [showawaitingpayment, setshowawaitingpayment] = useState(false);

    const [showpaymentreceived, setshowpaymentreceived] = useState(false);

    const [currenttrackingno, setcurrenttrackingno] = useState('');


    const handleSubmit = (event) => {
        event.preventDefault()
        seterror(null)
        setloading(true)
        axios.post(Postsearchrequest, {
            name: name,
            email: email,
            phone: phone,
            mphone: mphone,
            mode: mode,
            plan: plan,
            budget: budget,
            timeframe: timeframe,
            roomtype: roomtype,
            facilities: facilities,
            distance: distance,
            location: location,
            aob: aob ? aob : 'N/A',
        }).then(response => {
            setloading(false)
            if (!response.data.error) {
                setsuccess("Request received. Awaiting payment")
                setcurrenttrackingno(response.data.trackingno)
                savetrackingnumber(response.data.trackingno)
                setTimeout(() => {
                    setsuccess('')
                    setshowawaitingpayment(true)
                    checkPaymentStatus(response.data.trackingno)
                }, 3000);

            } else {
                seterror(response.data.message)
            }
            // 
        }).catch(error => {
            setloading(false)
            seterror("Sorry an error occurred,try again later");
        });
    };

    //save tracking number
    const savetrackingnumber = (trackingno) => {
        if (trackingnumbers?.length > 0) {
            trackingnumbers.push(trackingno)
            settrackingnumbers(trackingnumbers)
        } else {
            settrackingnumbers([trackingno])
        }
    }

    //check payment status
    const checkPaymentStatus = (trackingno) => {
        const interval = setInterval(() => {
            axios.post(Fetchsearchrequesturl, {
                trackingno: trackingno
            }).then(response => {
                if (!response.data.error) {
                    const paymentStatus = response.data?.paymentstatus;
                    if (paymentStatus === 'paid') {
                        clearInterval(interval); // Clear the interval
                        setshowpaymentreceived(true);
                        setTimeout(() => {
                            ondismiss();
                        }, 3000);
                    }
                }
            }).catch(error => {
                console.error('An error occurred:', error);
            });
        }, 3000); // Check every 3 seconds
    };

    //on change room type
    const onchangeroomtype = (choosenroomtype) => {
        setRoomtype(choosenroomtype.label)
        const distances = choosenroomtype.distances;
        distances.forEach(element => {
            element.label = `${element.distance} (${currencyseperator(element.price)}ksh)`
            element.value = element
        });
        setdistancearray(distances)
    }

    //on change distance
    const onchangedistance = (choosendistance) => {
        setBudget(choosendistance.price)
        setDistance(choosendistance.distance)
    }

    //on choose facilities
    const onchoosefacilities = (choosenfacilities) => {
        function extractSelectedValues(roomDetails) {
            const selectedValues = roomDetails
                .filter((detail) => detail.value)
                .map((detail) => detail.value);

            return selectedValues.join(",");
        }
        setFacilities(extractSelectedValues(choosenfacilities))
    }


    return (
        <div>
            {error?.length > 0 && <Erroralert onClose={() => seterror()} message={error} />}
            {success?.length > 0 && <Successalert onClose={() => setsuccess()} message={success} />}
            <div>
                <Backbutton onClick={() => ongoback()} />
            </div>
            Let's Get your data
            {showawaitingpayment ?
                <p align="middle">
                    <h3 style={{ color: "red" }}>DO NOT CLOSE THIS WINDOW</h3>
                    <h4>YOUR TRACKING NUMBER IS <b style={{ color: "red" }}>{currenttrackingno}</b>.PLEASE ENSURE YOU SAVE IT FOR TRACKING YOUR REQUEST.</h4>
                    <Lottie animationData={showpaymentreceived ? successlottie : paymentlottie} style={{ height: 200 }} loop={showpaymentreceived ? false : true} autoplay={true} />
                    {showpaymentreceived ? 'Success. Payment received' : ' processing payment..'}
                </p> :
                <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
                    <div className='clientform'>
                        What's your Name ?*
                        <TextField margin="normal" disabled={user?.username} value={name} onChange={(e) => setName(e.target.value)} required fullWidth variant="standard" autoComplete="name" autoFocus /><br />
                        What's your email ?*
                        <TextField margin="normal" disabled={user?.email} value={email} onChange={(e) => setEmail(e.target.value)} required fullWidth variant="standard" autoComplete="email" /><br />
                        What's your contact Number ?*
                        <TextField margin="normal" disabled={user?.phone} value={phone} onChange={(e) => setPhone(e.target.value)} required fullWidth variant="standard" autoComplete="tel" /><br />
                        What's your M-pesa Number to be used for payment?*
                        <TextField margin="normal" value={mphone} onChange={(e) => setMPhone(e.target.value)} required fullWidth variant="standard" /><br />
                        How should we contact you?(whatsapp,sms,call)*
                        <Select menuPlacement="bottom" options={contacttypes} onChange={e => setMode(e.value)}></Select><br />
                        Preferred hostel payment plan (Monthly/per semester)*
                        <TextField margin="normal" disabled value={plan} required fullWidth variant="standard" /><br />
                        When would you like to movein?(days time)*
                        <Select menuPlacement="bottom" options={numberofdays} onChange={e => setTimeframe(e.value)}></Select><br />
                        What's your preferred Room type?(Bedsitter,single room,etc)*
                        <Select menuPlacement="bottom" options={semesterroomtypes} onChange={e => onchangeroomtype(e)}></Select><br />
                        {distancearray &&
                            <div>
                                Preference in terms of distance from the school?
                                <Select menuPlacement="bottom" options={distancearray} onChange={e => onchangedistance(e)}></Select><br />
                            </div>
                        }
                        Which facilities do you want your room to have?(bed,chair,kitchen sink)*
                        <Select menuPlacement="bottom" isMulti options={roomdetails} onChange={onchoosefacilities}></Select><br />
                        Do you have any preference in hostel's location? *
                        <TextField margin="normal" value={location} onChange={(e) => setLocation(e.target.value)} required fullWidth variant="standard" /><br />
                        Any other thing you feel  we should know?
                        <TextField margin="normal" value={aob} onChange={(e) => setAob(e.target.value)} fullWidth variant="standard" /><br />
                        <br />
                        {loading && <LinearProgress color='primary' />}
                        <Button type="submit">submit</Button>
                    </div>
                </Box>}
        </div>
    )
}

//check request status
const Checksearchstatus = ({ ongoback, ondismiss }) => {
    const [loading, setloading] = useState(false);
    const [error, seterror] = useState('');
    const [success, setsuccess] = useState('');

    const [searchdata, setsearchdata] = useState('');


    //modals
    const [showcheckstatus, setshowcheckstatus] = useState(true);
    const [showsearchinfo, setshowsearchinfo] = useState(false);
    const [showforgotnumber, setshowforgotnumber] = useState(false);

    //check status
    const checkstatus = (event) => {
        event.preventDefault()
        const data = new FormData(event.currentTarget);
        seterror(null)
        setloading(true)
        axios.post(Fetchsearchrequesturl, {
            trackingno: data.get('trackingno')
        }).then(response => {
            setloading(false)
            if (!response.data.error) {
                setsearchdata(response.data)
                setshowcheckstatus(false)
                setshowsearchinfo(true)
            } else {
                seterror(response.data.message)
            }
        }).catch(error => {
            setloading(false)
            seterror("Sorry an error occurred,try again later");
        });
    }

    //make payment
    const makepayrequest = () => {
        seterror(null)
        setloading(true)
        axios.post(Postsearchrequest, {
            id: searchdata.id,
            name: searchdata.name,
            email: searchdata.email,
            phone: searchdata.phone,
            mphone: searchdata.mphone
        }).then(response => {
            setloading(false)
            if (!response.data.error) {
                setsuccess("Request received. Awaiting payment")
                setTimeout(() => {
                    setsuccess('')
                    ongoback()
                }, 3000);

            } else {
                seterror(response.data.message)
            }
            // 
        }).catch(error => {
            console.log(error)
            setloading(false)
            seterror("Sorry an error occurred,try again later");
        });
    }

    //receive tracking number
    const receivetrackingnumber = (event) => {
        event.preventDefault()
        const data = new FormData(event.currentTarget);
        seterror(null)
        setloading(true)
        axios.post(Recovertrackingnumberurl, {
            email: data.get('email')
        }).then(response => {
            setloading(false)
            if (!response.data.error) {
                setsuccess("Tracking number has been sent to your email.")
                setTimeout(() => {
                    ondismiss()
                    setsuccess('')
                }, 4000);
            } else {
                seterror(response.data.message)
            }
        }).catch(error => {
            setloading(false)
            seterror("Sorry an error occurred,try again later");
        });
    }


    return (
        <div>
            {error?.length > 0 && <Erroralert onClose={() => seterror()} message={error} />}
            {success?.length > 0 && <Successalert onClose={() => setsuccess()} message={success} />}
            <div>
                <Backbutton onClick={() => ongoback()} />
            </div>
            {showcheckstatus &&
                <div>
                    Enter your tracking Number:
                    <Box component={"form"} onSubmit={checkstatus} >
                        <TextField label="Tracking No" margin="normal" id="trackingno" name="trackingno" required fullWidth autoFocus /><br />
                        {loading && <LinearProgress color='primary' />}
                        {loading && <br />}
                        <Button variant='contained' type="submit">submit</Button>
                        <br /><br />
                        <div onClick={() => {
                            setshowcheckstatus(false)
                            setshowforgotnumber(true)
                            setshowsearchinfo(false)
                        }} className='forgottenbutton'>Forgotten your tracking Number?</div>
                    </Box>
                </div>
            }
            {showforgotnumber &&
                <div>
                    Enter your email to receive your tracking number
                    <Box component={"form"} onSubmit={receivetrackingnumber} >
                        <TextField label="Email" margin="normal" id="email" name="email" autoComplete='email' required fullWidth autoFocus /><br />
                        {loading && <LinearProgress color='primary' />}
                        {loading && <br />}
                        <Button variant='contained' type="submit">submit</Button>

                    </Box>
                </div>
            }
            {showsearchinfo &&
                <div className='trackinginfodiv'>
                    <div className='trackinginfo'>
                        <div className='infoname'>Tracking Number: </div>
                        <div className='infotext'>{searchdata.trackingno} </div>
                    </div>
                    <div className='trackinginfo'>
                        <div className='infoname'>Name </div>
                        <div className='infotext'>{searchdata.name} </div>
                    </div>
                    <div className='trackinginfo'>
                        <div className='infoname'>Phone Number </div>
                        <div className='infotext'>{searchdata.phone} </div>
                    </div>
                    <div className='trackinginfo'>
                        <div className='infoname'>Payment status: </div>
                        <div className='infotext'>{searchdata.paymentstatus} </div>
                    </div>
                    <div>
                        <div className='infoname'>Search status </div>
                        <div className='infolongtext'>{searchstatusinfo(searchdata)} </div>
                    </div>
                    <i style={{ fontSize: 12, marginTop: 5 }}>For any enquiries contact {admindetails.phone}</i><br />
                    {loading && <LinearProgress color='primary' />}
                    {loading && <br />}
                    <div style={{ display: "flex", marginTop: 5 }}>
                        <Button variant="outlined" sx={{ alignSelf: "right" }} onClick={() => ondismiss()} startIcon={<Clear />}>DISMISS</Button>&nbsp;&nbsp;
                        {searchdata.paymentstatus === 'unpaid' &&
                            <Button onClick={() => makepayrequest()} variant='contained'>Pay</Button>
                        }
                    </div>

                </div>
            }
        </div>
    )
}

//search status info
const searchstatusinfo = (searchinfo) => {
    if (searchinfo.paymentstatus === 'paid' && searchinfo.searchstatus === 'pending') {
        return 'An agent is currently searching for a match. You will be contacted as soon as an hostel is found.Thank you'
    }
    else if (searchinfo.paymentstatus === 'unpaid') {
        return 'Complete your payment for you to be assigned an agent'
    }
    else if (searchinfo.searchstatus === 'found') {
        return 'Hostel fouhd. You will be contacted ASAP.'
    }

}